import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { PersonaService } from 'src/app/servicios/persona.service';
import { MatDialog } from '@angular/material/dialog';

import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { DialogEditPersonaComponent } from 'src/app/dialogs/dialog-edit-persona/dialog-edit-persona.component';

import Swal from 'sweetalert2/dist/sweetalert2.all.js'; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { HelperService } from 'src/app/servicios/helper.service';

declare let $: any;

@Component({
  selector: 'app-consulta-persona',
  templateUrl: './consulta-persona.component.html',
  styleUrls: ['./consulta-persona.component.css']
})
export class ConsultaPersonaComponent implements OnInit {
  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  //dtOptions: DataTables.Settings = {};
  dtOptions:any = {};
  dataPersona = [];
  haveData = false;
  loading = false;
  timeRunning = 0;

  dtTrigger = new Subject();

  personaGroup: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private servicePersona: PersonaService,
    private dialog: MatDialog,
    private helper: HelperService
  ) {
    this.personaGroup = this.formBuilder.group({
      persona: ['']
    });

    /**/
  }

  ngOnInit() { }

  busqueda(event: any) {
    const busqueda = event.target.value;
    this.dtOptions = {
      pagingType: 'full_numbers',
      dom: 'Bfrtip',
      buttons: [
        'copy', 'csv', 'excel', 'pdf', 'print'
      ]
    };
    this.loading = true;
    this.servicePersona.getBusquedaPersona(busqueda).subscribe(data => {
      this.dataPersona = data;
      this.loading = false;
      if (data.length > 0) {
        this.haveData = true;
      }

      if (this.timeRunning == 0) {
        this.dtTrigger.next();
      } else {
        this.reRender();
      }
      this.timeRunning++;
    });
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  reRender() {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again

      this.dtTrigger.next();
    });
  }

  editarPersona(persona) {
    const dialogRef = this.dialog.open(DialogEditPersonaComponent, {
      data: persona,
      width: '100em',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.refrescaBusqueda();
      }
      console.log('Resultado es :' + result);
    });
  }

  eliminarPersona(persona) {
    //alert(JSON.stringify(persona));
    Swal.fire({
      title: 'Eliminar Persona?',
      text:
        'Esta seguro que desea eliminar esta persona, recuerde que las direcciones y usuarios asociados se eliminarán igualmente!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si, Eliminar!'
    }).then(result => {
      if (result.value) {
        this.servicePersona
          .deletePersona(persona.IdPersona)
          .subscribe(data => {
            const indexPersona = this.helper.findIndex(this.dataPersona, {
              IdPersona: persona.IdPersona
            });
            this.dataPersona.splice(indexPersona, 1);
            Swal.fire('Eliminado!', 'Registro Eliminado.', 'success');
          });
      }
    });
  }

  refrescaBusqueda() {
    const busqueda = this.personaGroup.controls['persona'].value;
    this.dtOptions = {
      pagingType: 'full_numbers',
      dom: 'Bfrtip',
      buttons: [
        'copy', 'csv', 'excel', 'pdf', 'print'
      ]
    };
    this.loading = true;
    this.servicePersona.getBusquedaPersona(busqueda).subscribe(data => {
      this.dataPersona = data;
      this.loading = false;
      if (data.length > 0) {
        this.haveData = true;
      }

      if (this.timeRunning == 0) {
        this.dtTrigger.next();
      } else {
        this.reRender();
      }
      this.timeRunning++;
    });
  }

}
